import { createRoot } from 'react-dom/client';

// style.scss
import 'assets/style.css';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import { AuthProvider } from 'contexts/AuthContext';
import { SubscriptionProvider } from 'contexts/SubscriptionContext';
import reportWebVitals from './reportWebVitals';

// Listen for Vite preload errors or dynamic module import failures
// (e.g. when chunks are updated/missing after a deployment update)
// and automatically reload the page to fetch the latest index.html and chunk paths.
const handleChunkError = (event) => {
  const error = event?.reason || event?.error || event;
  const msg = error?.message || (typeof error === 'string' ? error : '');
  const isChunkError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    error?.name === 'ChunkLoadError';

  if (isChunkError) {
    const reloadKey = 'chunk_reload_' + window.location.pathname;
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true');
      window.location.reload();
    }
  }
};

window.addEventListener('vite:preloadError', (event) => {
  event?.preventDefault?.();
  const reloadKey = 'chunk_reload_' + window.location.pathname;
  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, 'true');
    window.location.reload();
  }
});

window.addEventListener('error', handleChunkError);
window.addEventListener('unhandledrejection', handleChunkError);

const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <AuthProvider>
      <SubscriptionProvider>
        <App />
      </SubscriptionProvider>
    </AuthProvider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
